import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { SUPPORTED_LOCALES, useI18n, type Locale } from "@/lib/i18n";
import NotFound from "@/pages/NotFound";

/**
 * Wraps locale-prefixed routes. Validates `:locale` param against SUPPORTED_LOCALES,
 * syncs i18n state to URL, otherwise renders the 404 page.
 */
export function LocaleGate() {
  const { locale: paramLocale } = useParams<{ locale: string }>();
  const { locale: current, setLocale } = useI18n();

  const valid = paramLocale && SUPPORTED_LOCALES.includes(paramLocale as Locale)
    ? (paramLocale as Locale)
    : null;

  useEffect(() => {
    if (valid && valid !== current) setLocale(valid);
  }, [valid, current, setLocale]);

  if (!valid) return <NotFound />;
  return <Outlet />;
}

/** Ensures locale is reset to TR when on root (un-prefixed) routes. */
export function RootLocaleSync() {
  const { locale, setLocale } = useI18n();
  useEffect(() => {
    if (locale !== "tr") setLocale("tr");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Outlet />;
}
